"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function ServicesRepository($resource) {
    var create = {
        method: 'POST',
        isArray: false
    };
    return $resource('/partner/api/v2/servicesapi', {}, {
        create: create
    });
}
exports.ServicesRepository = ServicesRepository;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VydmljZXMuYXBpLmZhY3RvcnkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzZXJ2aWNlcy5hcGkuZmFjdG9yeS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUdBLFNBQWdCLGtCQUFrQixDQUFDLFNBQTRDO0lBRTNFLElBQUksTUFBTSxHQUF1QztRQUM3QyxNQUFNLEVBQUUsTUFBTTtRQUNkLE9BQU8sRUFBRSxLQUFLO0tBQ2pCLENBQUM7SUFFRixPQUFvQixTQUFTLENBQUMsNkJBQTZCLEVBQUUsRUFBRSxFQUFFO1FBQzdELE1BQU0sUUFBQTtLQUNULENBQUMsQ0FBQztBQUNQLENBQUM7QUFWRCxnREFVQyJ9